import { BlackListRequest, BlackListResponse, BlackListRow, BlackListStateModel } from "./models";

export const getBlackListRows = (state: BlackListStateModel): BlackListResponse => {
  return state.data;
}

export const getSelectedEntry = (state: BlackListStateModel): BlackListRow | undefined => {
  return state.entry;
}

export const getOpenDialog = (state: BlackListStateModel): boolean => {
  return state.openDialog;
}

export const getFilters = (state: BlackListStateModel): BlackListRequest => {
  return state.filters;
}

export const isLoading = (state: BlackListStateModel): boolean => {
  return state.isLoading;
}